import React from 'react';
import { FaPlus } from 'react-icons/fa';
import '../styles/Team.css';

const AdminTeam = () => {
  const team = ['Isaac Musa','Apollo Mwangi','Felister Mbithe','Moses Wainaina','Brian Mwenyeke'];
  return (
    <div className="team-page">
      <h1>Team Members</h1>
      <p>Manage your team members.</p>
      <button className="add-btn"><FaPlus /> Add Team Member</button>
      <table className="team-table">
        <thead><tr><th>#</th><th>Name</th><th>Role</th><th>Image</th><th>Actions</th></tr></thead>
        <tbody>{team.map((name,i)=>(<tr key={i}><td>{i+1}</td><td>{name}</td><td>Team Member</td><td>team-{i+1}.jpg</td><td><button className="edit-btn">Edit</button> <button className="delete-btn">Delete</button></td></tr>))}</tbody>
      </table>
    </div>
  );
};
export default AdminTeam;
